var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "about-children" }, [
    _c(
      "div",
      { class: ["about-children__wrapper", _vm.customBackground] },
      [
        [
          _c("BaseTitle", {
            staticClass: "about-children__title",
            attrs: { text: _vm.titleText }
          }),
          _c("div", { staticClass: "about-children__text" }, [
            _c(
              "div",
              { staticClass: "about-children__container" },
              [
                _c("BaseText", {
                  staticClass: "about-children__descr",
                  attrs: { text: _vm.text }
                })
              ],
              1
            )
          ]),
          _c("ul", { staticClass: "about-children__list" }, [
            _vm.questionnaireDocUrl
              ? _c(
                  "li",
                  { staticClass: "about-children__item" },
                  [
                    _c("BaseDownloadBtn", {
                      staticClass: "about-children__btn",
                      attrs: {
                        customClass: "default",
                        text: _vm.applicationText,
                        href: "" + _vm.RESOURCES_URL + _vm.questionnaireDocUrl,
                        download: "",
                        target: "_blank"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "li",
              {
                staticClass: "about-children__item",
                class: { full_width: !_vm.questionnaireDocUrl }
              },
              [
                _c("BaseBtn", {
                  staticClass: "about-children__btn",
                  class: { "btn--disabled": _vm.questionnaireDisabled },
                  attrs: {
                    customClass: "default",
                    text: _vm.questionnaireText,
                    to: "/request-form"
                  }
                })
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "about-children__item" },
              [
                _c("BaseBtn", {
                  staticClass: "about-children__btn",
                  attrs: {
                    customClass: "default-text",
                    text: _vm.questionnaireButton,
                    to: "/terms"
                  }
                })
              ],
              1
            )
          ])
        ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ebd1e04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ebd1e04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AboutWorldContest.vue
// module id = 4AxX
// module chunks = 2